export function getEnvironment(): "dev" | "integration" | "staging" | "live" {
    const hostname = window.location.hostname

    if (hostname === "localhost" || hostname === "127.0.0.1" || hostname.startsWith("192.168.10.")) {
        return "dev"
    } else if (hostname.indexOf("-int") >= 0) {
        return "integration"
    } else if (hostname.indexOf("-stage") >= 0) {
        return "staging"
    } else {
        return "live"
    }
}

export function getEnvironmentShort(): "dev" | "int" | "stage" | "live" {
    switch (getEnvironment()) {
        case "dev":
            return "dev"
        case "integration":
            return "int"
        case "staging":
            return "stage"
        default:
            return "live"
    }
}

export function getProtocolAndHost() {
    const environment = getEnvironment();
    return environment === "dev" ? "http://localhost:8080" : `https://${environment}.messebackend.aws.corussoft.de`;
}

export function getAppUrl() {
    return window.location.protocol + '://' + window.location.hostname + ':' + window.location.port
}